import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import classNames from "classnames";
import { BracketCurly, Heart } from "@boxicons/react";

import { useSiteContext } from "../hooks";

export default function Footer() {
  const { isDarkThemeActive } = useSiteContext();
  const data = useStaticQuery(graphql`
    query {
      allContentfulPerson {
        nodes {
          fullName
          specialization
        }
      }
      allContentfulMetadata {
        nodes {
          source
        }
      }
    }
  `);

  const authorFullName = data.allContentfulPerson.nodes[0].fullName;
  const authorSpecialization = data.allContentfulPerson.nodes[0].specialization;
  const authorFirstName = authorFullName.split(" ")[0];
  const siteSourceCode = data.allContentfulMetadata.nodes[0].source;
  const copyrightYear = new Date().getFullYear();

  const sourceLinkClassName = classNames("source", {
    "light": !isDarkThemeActive,
    "dark": isDarkThemeActive,
  });

  const authorLinkClassName = classNames("author", {
    "light": !isDarkThemeActive,
    "dark": isDarkThemeActive,
  });

  return (
    <footer className="site-footer">
      <div className="container">
        <div>
          <div className={authorLinkClassName}>
            <span className="name">{authorFullName}</span>
            <span className="spec">{authorSpecialization}</span>
          </div>
          <p className={sourceLinkClassName}>
            <a href={siteSourceCode} target="_blank" rel="noreferrer">
              <BracketCurly />
              with
              <Heart pack="filled" />
              by {authorFirstName}.
            </a>
            <span className="copy">&copy;2021-{copyrightYear}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
